import { RetriggerWebhookRequest } from 'vopay';
import { useApi } from '#shared/providers/Api';

export default function useResendWebhook() {
  const api = useApi();

  async function resendWebhook(params: RetriggerWebhookRequest) {
    try {
      const res = await api.resendWebhook(params);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  return { resendWebhook };
}
